//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { DocumentTypeConfigurationRequirementDto } from './models/document-type-configuration-requirement-dto.model';
import { RequirementDescriptionDetailsDto } from './models/requirement-description-details-dto.model';
import { RequirementDescriptionDto } from './models/requirement-description-dto.model';
import { RequirementDescriptionUpdateRequestDto } from './models/requirement-description-update-request-dto.model';
import { RequirementDescriptionUpdateResponseDto } from './models/requirement-description-update-response-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class RequirementDescriptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getRequirementDescription(requirementId: number, requirementLevel: string | null | undefined, associationId: number | null | undefined, facilityId: number | null | undefined, stateId: number | null | undefined, includeHierarchicalDescriptions: boolean | undefined): Observable<RequirementDescriptionDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/requirement/{requirementId}/description?";
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (requirementLevel !== undefined && requirementLevel !== null)
            url_ += "RequirementLevel=" + encodeURIComponent("" + requirementLevel) + "&";
        if (associationId !== undefined && associationId !== null)
            url_ += "AssociationId=" + encodeURIComponent("" + associationId) + "&";
        if (facilityId !== undefined && facilityId !== null)
            url_ += "FacilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (stateId !== undefined && stateId !== null)
            url_ += "StateId=" + encodeURIComponent("" + stateId) + "&";
        if (includeHierarchicalDescriptions === null)
            throw new Error("The parameter 'includeHierarchicalDescriptions' cannot be null.");
        else if (includeHierarchicalDescriptions !== undefined)
            url_ += "IncludeHierarchicalDescriptions=" + encodeURIComponent("" + includeHierarchicalDescriptions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementDescriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementDescriptionDto>;
        }));
    }

    protected processGetRequirementDescription(response: HttpResponseBase): Observable<RequirementDescriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequirementDescriptionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addOrUpdateRequirementDescription(requirementId: number, requirementDescriptionCreate: RequirementDescriptionUpdateRequestDto): Observable<RequirementDescriptionUpdateResponseDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/requirement/{requirementId}/description";
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requirementDescriptionCreate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateRequirementDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateRequirementDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementDescriptionUpdateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementDescriptionUpdateResponseDto>;
        }));
    }

    protected processAddOrUpdateRequirementDescription(response: HttpResponseBase): Observable<RequirementDescriptionUpdateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequirementDescriptionUpdateResponseDto;
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWinningDescriptionsByContractId(requirementId: number, contractId: number, includeInternal: boolean | undefined, includeExternal: boolean | undefined): Observable<DocumentTypeConfigurationRequirementDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/requirement/{requirementId}/contract/{contractId}/description?";
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (includeInternal === null)
            throw new Error("The parameter 'includeInternal' cannot be null.");
        else if (includeInternal !== undefined)
            url_ += "includeInternal=" + encodeURIComponent("" + includeInternal) + "&";
        if (includeExternal === null)
            throw new Error("The parameter 'includeExternal' cannot be null.");
        else if (includeExternal !== undefined)
            url_ += "includeExternal=" + encodeURIComponent("" + includeExternal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWinningDescriptionsByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWinningDescriptionsByContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeConfigurationRequirementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeConfigurationRequirementDto[]>;
        }));
    }

    protected processGetWinningDescriptionsByContractId(response: HttpResponseBase): Observable<DocumentTypeConfigurationRequirementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTypeConfigurationRequirementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRequirementDescriptionDetails(requirementId: number, facilityId: number | null | undefined, associationId: number | null | undefined, stateId: number | null | undefined): Observable<RequirementDescriptionDetailsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/requirement/{requirementId}/description/details?";
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (facilityId !== undefined && facilityId !== null)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        if (associationId !== undefined && associationId !== null)
            url_ += "associationId=" + encodeURIComponent("" + associationId) + "&";
        if (stateId !== undefined && stateId !== null)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementDescriptionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementDescriptionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequirementDescriptionDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequirementDescriptionDetailsDto>;
        }));
    }

    protected processGetRequirementDescriptionDetails(response: HttpResponseBase): Observable<RequirementDescriptionDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequirementDescriptionDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}